import { NavLink } from "react-router-dom";
import { AlertTriangle, LifeBuoy } from "lucide-react";
import { cn } from "@/lib/utils";

export function SupportTriageTabs() {
  const itemClass = ({ isActive }: { isActive: boolean }) =>
    cn(
      "inline-flex h-9 items-center gap-2 rounded-lg px-3 text-[12.5px] font-medium transition-colors",
      isActive
        ? "bg-zinc-900 text-white"
        : "text-zinc-600 hover:bg-zinc-100 hover:text-zinc-900",
    );

  return (
    <nav className="mb-4 inline-flex rounded-xl border border-zinc-200/80 bg-white p-1 shadow-[0_1px_2px_rgba(0,0,0,0.02)]">
      <NavLink to="/admin/support" end className={itemClass}>
        <LifeBuoy className="h-3.5 w-3.5" />
        Requests
      </NavLink>
      <NavLink to="/admin/support/incidents" end className={itemClass}>
        <AlertTriangle className="h-3.5 w-3.5" />
        Incidents
      </NavLink>
    </nav>
  );
}
